import Layout from "../../elements/layout";

export default function TaarufPage() {
  return (
    <Layout>
      <p>Ta'aruf page</p>
    </Layout>
  );
}
